/* eslint-disable */
export default {
  save: 'Guardar',
} as const;

// @key: @#@"save"@#@ @source: @#@"Save"@#@
